/* eslint-disable quotes */
import * as XLSX from "xlsx";

const excelToJson = async (excelFile: File) => {
	const file = excelFile;
	const reader = new FileReader();
	return new Promise((resolve, reject) => {
		reader.onerror = () => {
			reader.abort();
			reject(new DOMException("Problem parsing input file."));
		};

		reader.onload = function (excel) {
			try {
				if (excel.target) {
					const data: string | ArrayBuffer | null = excel.target.result;
					const readedData = XLSX.read(data, { type: "binary", dateNF: "YYYY-MM-DD" });
					const wsname = readedData.SheetNames[0];
					const ws = readedData.Sheets[wsname];
					const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });
					resolve(dataParse);
				}
			} catch (err: unknown) {
				if (typeof err === "string") {
					reject(new DOMException(err));
				}
				reject(err);
			}
		};
		if (file) {
			reader.readAsBinaryString(file);
		}
	});
};

export default excelToJson;
